import IconGitHub from '@/components/assets/icon_github.svg'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import ViverseButton from '@/components/ViverseButton'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

type GithubButtonProps = {
  className?: string
  iconClassName?: string
}

export default function GithubButton({ className, iconClassName }: GithubButtonProps) {
  const t = useTranslations()
  const { roomData } = useCheckEnterRoomContext()
  const githubUrl = roomData.github_url
  const isShowButton = githubUrl && githubUrl.length > 0

  if (!isShowButton) return null

  return (
    <Tooltip>
      <TooltipTrigger>
        <Link href={githubUrl} target="_blank">
          <ViverseButton
            className={cn('group aspect-square min-w-fit shrink-0 gap-2', className)}
            variant="filter"
          >
            <IconGitHub className={iconClassName} />
          </ViverseButton>
        </Link>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        sideOffset={8}
        className="bg-vive-primary-70 text-vive-primary-20 subheader-3 z-1001 h-[52px] max-h-40.5 w-60 rounded-[3px] px-4 text-sm text-pretty"
      >
        {t('github-button.tips')}
      </TooltipContent>
    </Tooltip>
  )
}
